import { useDispatch } from "react-redux";
import { AppDispatch } from "../configureStore";

const useAppDispatch = () => useDispatch<AppDispatch>();

export default useAppDispatch;
